import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "tips-container"
};
var _hoisted_2 = ["src"];
var _hoisted_3 = {
  class: "content"
};
var _hoisted_4 = {
  class: "logo-container"
};
var _hoisted_5 = ["src"];
var _hoisted_6 = {
  class: "actions"
};
var _hoisted_7 = ["href"];
var _hoisted_8 = ["src"];
var _hoisted_9 = ["href"];
var _hoisted_10 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: "download",
    style: _normalizeStyle($options.bgStyle)
  }, [$data.showTips ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
    src: $data.downtips,
    alt: "downtips"
  }, null, 8, _hoisted_2)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
    class: _normalizeClass([['logo', 'rotate'], "logo"]),
    src: $data.logo,
    alt: "logo"
  }, null, 8, _hoisted_5), _cache[2] || (_cache[2] = _createElementVNode("div", {
    class: "title"
  }, " 起泡 ", -1))]), _createElementVNode("div", _hoisted_6, [_createElementVNode("a", {
    class: "btn ios",
    href: $data.iosUrl,
    target: "_blank",
    rel: "noopener",
    onClick: _cache[0] || (_cache[0] = function () {
      return $options.onIosClick && $options.onIosClick.apply($options, arguments);
    })
  }, [_createElementVNode("img", {
    src: $data.ioslogo,
    alt: "iOS",
    class: "icon"
  }, null, 8, _hoisted_8), _cache[3] || (_cache[3] = _createTextVNode(" iOS 下载 ", -1))], 8, _hoisted_7), _createElementVNode("a", {
    class: "btn android",
    href: $data.androidUrl,
    target: "_blank",
    rel: "noopener",
    onClick: _cache[1] || (_cache[1] = function () {
      return $options.onAndroidClick && $options.onAndroidClick.apply($options, arguments);
    })
  }, [_createElementVNode("img", {
    src: $data.androidlogo,
    alt: "Android",
    class: "icon"
  }, null, 8, _hoisted_10), _cache[4] || (_cache[4] = _createTextVNode(" Android 下载 ", -1))], 8, _hoisted_9)])])], 4);
}